// frontend_react/src/pages/catalog/ProductSearch.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
import { PageContainer, PageTitle, ActionButton } from "../../ui";

export default function ProductSearch() {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <PageTitle>Recherche produit</PageTitle>
      <p>
        La recherche produit est désormais intégrée à la caisse par activité.
      </p>
      <ActionButton onClick={() => navigate("/cart")}>
        Aller à la caisse
      </ActionButton>
    </PageContainer>
  );
}